import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Newsletter from "../components/Newsletter";
import Breadcrumbs from "../components/Breadcrumbs";
import { getTranslatedPath } from "../utils/languageUtils";

export default function Giveaway({ setHeader }) {
  const { t, i18n } = useTranslation();
  const currentPaths = getTranslatedPath(i18n.language);
  const alternateLinks = [
    { hrefLang: "en", href: getTranslatedPath("en")["giveaway"] },
    { hrefLang: "sr", href: getTranslatedPath("sr")["giveaway"] },
  ];
  const breadcrumbs = [
    { name: t("header.home.menuTitle"), url: `/${i18n.language}` },
    { name: t("header.giveaway.pageTitle"), url: currentPaths["giveaway"] },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Seo
        title={t("header.giveaway.pageTitle")}
        description={t("header.giveaway.metaDescription")}
        path={currentPaths["giveaway"]}
        alternateLinks={alternateLinks}
        breadcrumbs={breadcrumbs}
      />
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img7">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("giveaway.title")}
                {/*<span className="watermark">{privacy.title}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs bg="light" />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Faq Section Start --> */}
        <div className="rs-faq gray-bg4 pt-120 md-pt-80">
          <div className="container">
            {/* <!-- Giveaway Section Start --> */}
            <div className="rs-privacy-policy pt-10 md-pt-80">
              <div className="privacy-wrap pb-130 md-pb-90">
                <div className="sec-title mb-50">
                  <h2 className="title title2">{t("giveaway.terms.title")}</h2>
                </div>
                <div className="privacy-content giveaway">
                  <div className="sec-title mb-30">
                    <h4 className="title">{t("giveaway.terms.subtitle_1")}</h4>
                  </div>
                  <p>
                    {t("giveaway.terms.eligibility.count_1")} <br />{" "}
                    {t("giveaway.terms.eligibility.count_2")}
                  </p>
                  <ul className="check-list">
                    <li>{t("giveaway.terms.eligibility.li1")}</li>
                    <li>{t("giveaway.terms.eligibility.li2")}</li>
                    <li>{t("giveaway.terms.eligibility.li3")}</li>
                    <li>{t("giveaway.terms.eligibility.li4")}</li>
                    <li>{t("giveaway.terms.eligibility.li5")}</li>
                  </ul>
                  <div className="sec-title mt-30 mb-30">
                    <h4 className="title">{t("giveaway.terms.subtitle_2")}</h4>
                  </div>
                  <p>
                    {t("giveaway.terms.prize.count_1")} <br />{" "}
                    {t("giveaway.terms.prize.count_2")}
                  </p>
                  <ul className="check-list">
                    <li>{t("giveaway.terms.prize.li1")}</li>
                    <li>{t("giveaway.terms.prize.li2")}</li>
                    <li>{t("giveaway.terms.prize.li3")}</li>
                  </ul>
                  <div className="sec-title mt-30 mb-30">
                    <h4 className="title">{t("giveaway.terms.subtitle_3")}</h4>
                  </div>
                  <ul className="check-list">
                    <li>{t("giveaway.terms.winner.li1")}</li>
                    <li>{t("giveaway.terms.winner.li2")}</li>
                    <li>{t("giveaway.terms.winner.li3")}</li>
                    <li>{t("giveaway.terms.winner.li4")}</li>
                  </ul>
                  <div className="sec-title mt-30 mb-30">
                    <h4 className="title">{t("giveaway.terms.subtitle_4")}</h4>
                  </div>
                  <ul className="check-list">
                    <li>{t("giveaway.terms.general.li1")}</li>
                    <li>{t("giveaway.terms.general.li2")}</li>
                    <li>{t("giveaway.terms.general.li3")}</li>
                    <li>{t("giveaway.terms.general.li4")}</li>
                    <li>{t("giveaway.terms.general.li5")}</li>
                    <li>{t("giveaway.terms.general.li6")}</li>
                    <li>{t("giveaway.terms.general.li7")}</li>
                    <li>{t("giveaway.terms.general.li8")}</li>
                    <li>{t("giveaway.terms.general.li9")}</li>
                    <p>
                      {t("giveaway.terms.general.count_1")}{" "}
                      <a href="mailto:info@parfimerija-duro.rs">
                        info@parfimerija-duro.rs
                      </a>
                      .
                    </p>
                  </ul>
                </div>
              </div>
            </div>
            {/* <!-- Giveaway Section End -->    */}
          </div>
          {/* <!-- Newsletter section start --> */}
          <div className="rs-newsletter style1 pt-90 md-pt-60 mb--65">
            <Newsletter />
          </div>
          {/* <!-- Newsletter section end --> */}
        </div>
        {/* <!-- Faq Section End --> */}
      </div>
      {/* <!-- Main content End --> */}
    </>
  );
}
